import { Box } from '../Box/Box';
import { Children, ReactNode } from 'react';

import { listContext } from './context';
import { listItemWrapperStyle } from './List.css';

interface ListProps {
  rounded?: boolean;
  drawDividers?: boolean;
  children: ReactNode[] | ReactNode;
}

export const List: React.FC<ListProps> = ({ rounded, drawDividers, children }: ListProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="none">
      <listContext.Provider value={{ rounded: Boolean(rounded) }}>
        {drawDividers
          ? Children.map(children, (child, index) => {
              if (index === 0) {
                return child;
              }
              return <Box className={listItemWrapperStyle}>{child}</Box>;
            })
          : children}
      </listContext.Provider>
    </Box>
  );
};
